<template>
  <div
    v-on="$listeners"
    class="shop-category"
    :class="{
      'shop-category--placeholder': placeholder,
      'shop-category--active': active,
      'shop-category--placeholder-external': external,
    }"
  >
    <input
      v-if="!placeholder"
      type="text"
      v-model="label"
      :style="{ width: inputMinWidth }"
      :disabled="placeholder"
      :readonly="isReadOnly || external"
      :placeholder="inputPlaceholder"
      @blur="visited = true"
      :class="[{ 'shop-category__label-external': external }, 'shop-category__label']"
    />
    <span v-else class="shop-category__label">{{ $t('shopAddCategory') }}</span>
    <FontAwesomeIcon v-if="hasError" class="shop-category__validation-icon ml-1" icon="exclamation-circle" />
    <FontAwesomeIcon v-if="placeholder" :icon="['fal', 'plus']" class="ml-1" />
    <FontAwesomeIcon v-if="isReadOnly" :icon="['fal', 'lock']" class="ml-1" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ContentEditable from '@/components/ContentEditable'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    index: Number,
    placeholder: Boolean,
    active: Boolean,
    external: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['validator'],
  data() {
    return {
      visited: false,
    }
  },
  computed: {
    ...mapState('Shop', ['item']),
    label: {
      get() {
        if (this.placeholder) return this.$t('shopAddCategory')
        return this.value.label
      },
      set(val) {
        this.value.label = val
      },
    },
    source() {
      return (this.item.categories || []).find(c => c.id === this.value.id)
    },
    isReadOnly() {
      if (!this.source) return false
      return ['signed', 'accepted'].includes(this.source.status)
    },
    inputPlaceholder() {
      return `${this.$t('typeHere')}... (${this.$t('shopCategoryExamples')})`
    },
    inputMinWidth() {
      if (!this.label) return this.inputPlaceholder.length + 'ch'
      return Math.max(5, this.label.length) + 'ch'
    },
    hasError() {
      let errors = Object.keys(this.validator.errors.errors)
      if (errors.includes(`categories.${this.index}.label`) && this.visited) return true
      if (errors.some(err => new RegExp(`^categories\.${this.index}\..+`).test(err)) && !this.active) return true
      return false
    },
  },
  methods: {
    onInput() {
      this.visited = true
    },
  },
  components: {
    ContentEditable,
  },
}
</script>

<style lang="scss">
.shop-category {
  padding: 1rem 2rem;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  scroll-snap-align: start;
  transition: background-color 150ms ease-out;
  white-space: nowrap;
  border-bottom: 1px solid var(--border-color);

  &:hover {
    background-color: rgba(black, 0.05);
  }

  &--active {
    border: 1px solid var(--border-color);
    border-top-color: var(--primary);
    border-bottom-color: transparent;
  }

  &:not(.shop-category--placeholder) {
    .shop-category__label {
      font-weight: bold;
    }
    &:not(.shop-category--placeholder-external) {
      &:before {
        counter-increment: shop-categories;
        content: counter(shop-categories) '.';
        margin-right: 0.5rem;
      }
    }
  }

  &.shop-category--placeholder-external {
    .shop-category__label-external {
      cursor: pointer;
      color: var(--dark);
    }
  }

  & > input {
    &:focus {
      outline: none;
    }
  }

  &--placeholder {
    color: css-alpha('dark', 0.5);
    flex-grow: 1;
  }

  &__validation-icon {
    color: var(--error);
    position: absolute;
    left: 1.4rem;
    background: white;
    border-radius: 50%;
  }

  &__options {
    .elder-dropdown__trigger .elder-button__icon {
      padding: 0.1rem 0.5rem !important;
    }
  }
}
</style>
